import { useState } from "react";
import { ReactSVG } from "react-svg";
import { transformDateToLocalDateString, useTranslate } from "helpers";
import { VehicleSpecificationProps } from "../types";
import { RegistrationEditModal } from "./RegistrationEditModal";

const VehicleRegistration: React.FC<VehicleSpecificationProps> = ({ fleetVehicleDetail, onRegistrationUpdate }) => {
    const { t } = useTranslate();
    const [showRegistrationModal, setShowRegistrationModal] = useState(false);

    const handleRegistrationSuccess = (registrationPlate: string, registrationExpiration: Date | null) => {
        onRegistrationUpdate?.(registrationPlate, registrationExpiration);
    };

    return (
        <>
            <div className="border-b border-slate-200 pt-4 px-4">
                <div className="flex items-center justify-between mb-3 ">
                    <div className="text-sm font-bold text-slate-600">
                        {t("admin.fleet.vehicle.detail.info.registration")}
                    </div>

                </div>
                <div className="grid grid-cols-4 gap-3 mb-4">
                    <div
                        className="relative border border-slate-200 bg-slate-50 p-3 rounded-sm  min-h-[70px] cursor-pointer hover:border-sky-300 transition-colors"
                        onClick={() => setShowRegistrationModal(true)}
                    >
                        <ReactSVG src="/media/icons/edit.svg" className="absolute top-2 right-2 [&_svg]:w-3.5 [&_svg]:h-3.5 [&_path]:stroke-slate-500 hover:[&_path]:stroke-sky-500 [&_path]:transition-colors" />
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.registrationplate")}
                        </div>
                        <div className="text-md font-medium truncate text-sky-600 hover:text-sky-700">
                            {fleetVehicleDetail.registrationPlate}
                        </div>
                    </div>
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.registrationexpiration")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {transformDateToLocalDateString(fleetVehicleDetail.registrationExpiration)}
                        </div>
                    </div>
                    <div className="border border-slate-200 bg-slate-50 p-3 rounded-sm min-h-[70px]">
                        <div className="text-sm text-slate-600">
                            {t("admin.fleet.vehicle.detail.info.firstregistrationdate")}
                        </div>
                        <div className="text-md font-medium text-slate-800 truncate">
                            {transformDateToLocalDateString(fleetVehicleDetail.firstRegistrationDate)}
                        </div>
                    </div>
                </div>
            </div>

            <RegistrationEditModal
                show={showRegistrationModal}
                onClose={() => setShowRegistrationModal(false)}
                onSuccess={handleRegistrationSuccess}
                vehicleId={fleetVehicleDetail.id ?? ""}
            />
        </>
    );
};

export default VehicleRegistration;

